import { render, staticRenderFns } from "./supervision.vue?vue&type=template&id=ca9935d6&scoped=true&"
import script from "./supervision.vue?vue&type=script&lang=js&"
export * from "./supervision.vue?vue&type=script&lang=js&"
import style0 from "./supervision.vue?vue&type=style&index=0&id=ca9935d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9935d6",
  null
  
)

export default component.exports